import { examComponentBase, userData } from "../../../types";
import './index.scss';
import { useNavigate } from "react-router-dom";
import withUser from "../../../wrappers/withUser";
import { Paid } from "@mui/icons-material";
import { Stack, Box, useMediaQuery } from "@mui/material";


const ExamComponentInfoTile = ({
    userData,
    examComponentBase
}:{
    userData: userData
    examComponentBase: examComponentBase
}) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:950px)");
    

    const handleTesterClick = (id:number) => {
        navigate(`/exam-launchpad/${id}`);
    };
    const handleAdminClick = () => {
        alert('Not yet implemented.');
    };

    return (
        <Stack direction='row' sx={{ width:'100%', mb:2, justifyContent:'center' }}>
            {!isMobile && (
                <Box
                    component="img"
                    src={examComponentBase.image ? `/images/${examComponentBase.image}` : '/images/CVESD_logo.png'}
                    sx={{ width: 100, height: "auto", maxWidth: "100%", bgcolor:'#8babf1', borderTopLeftRadius:20, borderBottomLeftRadius:20, p:2 }}
                />
            )}
            <div className="outer-shell">
                <div className="display-row">
                    <h4 
                    className="title" 
                    onClick={() => {
                        userData.user_type === 'district_admin'
                        ? handleAdminClick()
                        : handleTesterClick(examComponentBase.id);
                    }}
                    >
                    {examComponentBase.exam_component_title}
                    </h4>
                    <div className="token-count"><Paid/>{examComponentBase.cost}</div>
                </div>
                <p>{examComponentBase.description}</p>
                
            </div>
        </Stack>
    )
};

export default withUser(ExamComponentInfoTile);